<template>
    <div class="toggle-wrapper">
        <div class="option-one">{{optionOne || 'Yes'}}</div>
        <div class="toggle-container" :class="{on: toggle, off: !toggle}" 
            @click="toggle = !toggle;
                    $emit('toggle', toggle);">
            <div class="toggle"></div>
        </div>
        <div class="option-two">{{optionTwo || 'No'}}</div>
    </div>
</template>

<script>
    export default {
        props: [
            'optionOne',
            'optionTwo'
        ],
        data(){
            return {
                toggle: true
            }
        },
         mounted() {
            this.$emit("toggle", this.toggle);
        }
    }
</script>

<style lang="scss" scoped>
    .toggle-wrapper{
        margin-top: 20px;
        display: flex;
        .option-one, .option-two{
            // font-weight: bold;
            color: #171785;
        }
        .toggle-container{
            width: 70px;
            height: 32px;
            border: 2px solid  #171785;
            margin-left: 10px;
            margin-right: 10px;
            border-radius: 25px;
            padding: 5px;
            position: relative;
            cursor: pointer;
            .toggle{
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background-color: #171785;
                position: absolute;
                top: 4px;
                left: 5px;
                transition: all .3 ease-in-out;
            }
            &.on{
                .toggle{
                    left: 5px;
                }
            }
            &.off{
                .toggle{
                    left: 40px;
                }
            }
        }
    }
</style>